import { gql } from '@edreamsodigeo/frontend-api-client';
import { api as technicalStop } from './technicalStopover';

export const itinerarySearchSection = gql`
  fragment SectionInfo on ItinerarySearchResultSection {
    id
    departureDate
    arrivalDate
    duration
    departureId
    destinationId
    carrierId
    operatingCarrierId
    technicalStops {
      ...TechnicalStop
    }
    cabinClass
    flightCode
    departureTerminal
    arrivalTerminal
    vehicleModel
    transportType
    insuranceOfferId
  }

  ${technicalStop}
`;
